import { List } from 'immutable';
import { companyFinancialsConstants } from '../constants';

export function company_financials(state = {}, action) {
  switch (action.type) {
    case companyFinancialsConstants.COMPANY_FINANCIALS_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case companyFinancialsConstants.COMPANY_FINANCIALS_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case companyFinancialsConstants.COMPANY_FINANCIALS_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case companyFinancialsConstants.COMPANY_FINANCIALS_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case companyFinancialsConstants.COMPANY_FINANCIALS_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case companyFinancialsConstants.COMPANY_FINANCIALS_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case companyFinancialsConstants.COMPANY_FINANCIALS_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case companyFinancialsConstants.COMPANY_FINANCIALS_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const companyFinancialsIndex = state.items.findIndex(val => val.id == action.response.id);

      if (companyFinancialsIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(companyFinancialsIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case companyFinancialsConstants.COMPANY_FINANCIALS_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case companyFinancialsConstants.COMPANY_FINANCIALS_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case companyFinancialsConstants.COMPANY_FINANCIALS_DELETE_SUCCESS: {
      const { companyFinancialsId } = action;

      if (!state.items) {
        return state;
      }

      const companyFinancialsIndex = state.items.findIndex(val => val.id == companyFinancialsId);

      if (companyFinancialsIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(companyFinancialsIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case companyFinancialsConstants.COMPANY_FINANCIALS_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case companyFinancialsConstants.COMPANY_FINANCIALS_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
